var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "fragment",
    [
      _c("touchpoint-overview-row", {
        scopedSlots: _vm._u(
          [
            _vm.displaySource
              ? {
                  key: "left",
                  fn: function() {
                    return [
                      _c(
                        "touchpoint-statistics-overview-cell",
                        {
                          staticClass: "row",
                          attrs: {
                            category: _vm.categoryTypes.source,
                            "selected-category":
                              _vm.detailsSelectedCategoryLabel
                          },
                          on: { select: _vm.selectDetailsCategory }
                        },
                        [
                          _c("div", { staticClass: "col-2" }, [
                            _c("i", { class: _vm.sourceBrickIcon })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-10" }, [
                            _c("span", { staticClass: "description" }, [
                              _vm._v(_vm._s(_vm.sourceBrickName))
                            ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("span", { staticClass: "amount" }, [
                              _vm._v(
                                _vm._s(_vm._f("formatNumber")(_vm.sourceAmount))
                              )
                            ])
                          ])
                        ]
                      )
                    ]
                  },
                  proxy: true
                }
              : null,
            _vm.displaySelected
              ? {
                  key: "center",
                  fn: function() {
                    return [
                      _c(
                        "touchpoint-statistics-overview-cell",
                        {
                          attrs: {
                            category: _vm.categoryTypes.condition,
                            "selected-category":
                              _vm.detailsSelectedCategoryLabel
                          },
                          on: { select: _vm.selectDetailsCategory }
                        },
                        [
                          _c("span", { staticClass: "description" }, [
                            _vm._v(_vm._s(_vm.selectedName))
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "amount" }, [
                            _vm._v(
                              _vm._s(_vm._f("formatNumber")(_vm.selectedAmount))
                            )
                          ])
                        ]
                      )
                    ]
                  },
                  proxy: true
                }
              : null,
            _vm.displayDestination
              ? {
                  key: "right",
                  fn: function() {
                    return [
                      _c(
                        "touchpoint-statistics-overview-cell",
                        {
                          staticClass: "row",
                          attrs: {
                            category: _vm.categoryTypes.destination,
                            "selected-category":
                              _vm.detailsSelectedCategoryLabel
                          },
                          on: { select: _vm.selectDetailsCategory }
                        },
                        [
                          _c("div", { staticClass: "col-10" }, [
                            _c("span", { staticClass: "description" }, [
                              _vm._v(_vm._s(_vm.destinationBrickName))
                            ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("span", { staticClass: "amount" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("formatNumber")(_vm.destinationAmount)
                                )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-2" }, [
                            _c("i", { class: _vm.destinationBrickIcon })
                          ])
                        ]
                      )
                    ]
                  },
                  proxy: true
                }
              : null
          ],
          null,
          true
        )
      }),
      _vm._v(" "),
      _vm.displayDetails
        ? [
            !_vm.isLoadingDetails
              ? _c("touchpoint-statistics-details", {
                  key: _vm.detailsSelectedCategoryLabel,
                  attrs: { "statistics-details": _vm.detailsSelectedCategory },
                  on: { "filters-changed": _vm.detailsTypeFiltersChanged }
                })
              : _c("loading-box", { staticClass: "position-relative" })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }